import { render, staticRenderFns } from "./ManagersHistoryTab.vue?vue&type=template&id=9e93480a&scoped=true&"
import script from "./ManagersHistoryTab.vue?vue&type=script&lang=ts&"
export * from "./ManagersHistoryTab.vue?vue&type=script&lang=ts&"
import style0 from "./ManagersHistoryTab.vue?vue&type=style&index=0&id=9e93480a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e93480a",
  null
  
)

export default component.exports